// Route guard for the hidden /admin area. Redirects to /admin/login if not
// authenticated; supports role gating via the `roles` prop.
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/lib/adminAuth";

export default function AdminProtectedRoute({ children, roles }) {
    const { user, checking } = useAdminAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0b1f22] text-ivory">
                <div className="text-[10px] uppercase tracking-[0.32em] text-gold animate-pulse">Verifying session…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
    }
    if (roles && roles.length > 0 && user.role !== "super_admin" && !roles.includes(user.role)) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0b1f22] text-ivory px-6">
                <div className="max-w-md text-center">
                    <div className="text-[10px] uppercase tracking-[0.28em] text-gold">Restricted</div>
                    <h1 className="font-display text-3xl md:text-4xl mt-3">You don't have permission for this area</h1>
                    <p className="text-ivory/70 text-sm mt-4">Ask a Super Admin to grant your account the correct role.</p>
                </div>
            </div>
        );
    }
    return children;
}
